export default __webpack_public_path__ + "static/media/click.e3092b32.mp3";